import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['Juan', 'María', 'Carlos', 'Ana', 'Roberto', 'Silvia', 'Diego', 'Laura', 'Martín', 'Claudia'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const triggerPopup = () => {
    // Generate random data
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    // Show popup
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup (random between 8-12 seconds)
      const nextDelay = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(triggerPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-50 animate-slide-in-right max-w-xs w-full md:w-auto" data-id="element-213">
      <div className="bg-white rounded-lg shadow-2xl p-4 border-l-4 border-green-500 flex items-center gap-3" data-id="element-214">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-215">
          <CheckCircle className="w-6 h-6 text-green-600" data-id="element-216" />
        </div>
        <div data-id="element-217">
          <p className="text-sm font-medium text-gray-900" data-id="element-218">
            <span className="font-bold" data-id="element-219">{data.name}</span> de {data.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-220">
            acaba de comprar{' '}
            <span className="font-semibold text-blue-900" data-id="element-221">
              Micro y Macro Economía 360
            </span>
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-222">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}